<div class="or-pt-32-px or-mx-24-px action-push-modal">
  <div class="or-d-flex or-justify-content-center">
    <span class="or-head-xl or-mb-16-px or-text-align-center"
      >Komplementy i kartki - czyli system kultury w Orlikfy!</span
    >
  </div>

  <div class="or-text-lg or-mb-20-px">
    Dbamy o jakość i kulturę w aplikacji, dlatego wprowadziliśmy system kartek i komplementów. Na czym on polega?
  </div>

  <img class="or-mb-20-px or-w-100-pc" src="assets/action-push/penalties.jpg" />

  <div class="or-text-lg or-mb-20-px">Trzymaj poziom - przychodź na gierki, nie bądź wulgarny, graj fair play!</div>

  <div class="or-head-md or-mb-20-px">
    Inaczej organizator przyzna Ci czerwoną lub żółtą kartkę, która będzie widoczna w Twoim profilu!
  </div>

  <img class="or-mb-20-px or-w-100-pc" src="assets/action-push/comments.jpg" />

  <div class="or-text-lg or-mb-20-px">Odwrotność kartek - pokaż się dobrze, a organizator przyzna Ci komplement!</div>

  <div class="or-text-lg or-mb-20-px">Kartki i komplementy są widoczne w profilu użytkownika.</div>
</div>

<div class="or-mb-12-px or-mx-24-px or-mt-12-px">
  <button class="button-primary-style or-h-48-px or-head-md or-w-100-pc or-mb-12-px" (click)="closeModal()">
    Wróć do głównego ekranu
  </button>
</div>
